import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React from 'react';
import propTypes from 'prop-types';
import { Divider as Divider$1 } from '@chakra-ui/react';

var _excluded = ["orientation"];
var Divider = function Divider(_ref) {
  var _ref$orientation = _ref.orientation,
    orientation = _ref$orientation === void 0 ? 'horizontal' : _ref$orientation,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Divider$1, _extends({
    borderColor: "scheme.border",
    orientation: orientation,
    opacity: 1
  }, props));
};
Divider.propTypes = {
  orientation: propTypes.oneOf(['horizontal', 'vertical'])
};

export { Divider };
